var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4361 0.983154H2.05847C1.70367 0.983154 1.3634 1.12588 1.11252 1.37993C0.861646 1.63398 0.720703 1.97854 0.720703 2.33782V13.1752V15.8845C0.720703 16.2438 0.861646 16.5883 1.11252 16.8424C1.3634 17.0964 1.70367 17.2392 2.05847 17.2392H15.4361C15.7909 17.2392 16.1312 17.0964 16.382 16.8424C16.6329 16.5883 16.7739 16.2438 16.7739 15.8845V2.33782C16.7739 1.97854 16.6329 1.63398 16.382 1.37993C16.1312 1.12588 15.7909 0.983154 15.4361 0.983154ZM13.0365 7.75649C12.7846 7.50519 12.4453 7.36433 12.0917 7.36433C11.7381 7.36433 11.3987 7.50519 11.1469 7.75649L7.40952 11.5411L5.67879 9.78849C5.42694 9.5372 5.08756 9.39633 4.73399 9.39633C4.38042 9.39633 4.04105 9.5372 3.7892 9.78849L2.05847 11.5411V2.33782H15.4361V10.1864L13.0365 7.75649Z",
    fill: "#5FC4EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.8c214ddb2ff67eab6dbfb74c4e7a9c69.svg";
export { ForwardRef as ReactComponent };